import { Task } from "./types"; // Adjust the import path as needed
import { getUserID } from "../utils/userUtils";

const TASK_CRUD_BASE_URL = process.env.REACT_APP_TASK_CRUD_BASE_URL as string;

export const getTask = async (taskID: string): Promise<Task> => {
  const userID = getUserID(); // Get the userID from localStorage
  const url = `${TASK_CRUD_BASE_URL}/users/${userID}/tasks/${taskID}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Network response was not ok: ${errorText}`);
    }

    const task = await response.json();
    return task;
  } catch (error) {
    console.error("Failed to fetch task:", error);
    throw error;
  }
};

export const getUserTasks = async (): Promise<Task[]> => {
  const userID = getUserID(); // Get the userID from localStorage
  const url = `${TASK_CRUD_BASE_URL}/users/${userID}/all-tasks`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Network response was not ok: ${errorText}`);
    }

    const userTasks = await response.json();
    return userTasks;
  } catch (error) {
    console.error("Failed to fetch user's tasks:", error);
    throw error;
  }
};

// Import necessary elements or ensure this file has the necessary context
export const deleteTask = async (
  userID: string,
  taskID: string,
): Promise<void> => {
  const url = `${TASK_CRUD_BASE_URL}/users/${userID}/tasks/${taskID}`;

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete task: ${errorText}`);
    }
  } catch (error) {
    console.error("Failed to delete task:", error);
    throw error;
  }
};

// Track a new user
export const trackNewUser = async (): Promise<void> => {
  const url = `${TASK_CRUD_BASE_URL}/track-new-user`;

  try {
    await fetch(url, {
      method: "POST",
    });
  } catch (error) {
    console.error("Failed to track new user:", error);
  }
};
